import { Component } from '@angular/core';
import { IInvestigationTableConfig, TableType, Columns } from "../../investigations-table-view/investigations-table-new/investigations-table-new.component";

@Component({
  selector: 'app-investigation-list',
  templateUrl: './investigation-list.component.html',
  styleUrls: ['./investigation-list.component.scss']
})
export class InvestigationListComponent {

  public tableConfig: IInvestigationTableConfig = {
    type: TableType.investigations,
    displayedColumns: [
      Columns.investigationCol,
      Columns.detailsCol,
      Columns.priority,
      Columns.assigned,
      Columns.status,
      Columns.currentCol,
      Columns.actions,
      Columns.comments
    ],
    viewType: null,
    startWithCount: false
  };

  constructor() { }

}
